import { render, staticRenderFns } from "./havebacker.vue?vue&type=template&id=1b4ad411&scoped=true"
import script from "./havebacker.vue?vue&type=script&lang=js"
export * from "./havebacker.vue?vue&type=script&lang=js"
import style0 from "./havebacker.vue?vue&type=style&index=0&id=1b4ad411&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ad411",
  null
  
)

export default component.exports